import GoogleIcon from "@/components/icons/GoogleIcon";
import OAuthLoginButton from "./OAuthLoginButton";

export default function GoogleLoginButton({
  size
}: {
  size?: "md" | "lg";
}) {
  return (
    <OAuthLoginButton
      provider="google"
      icon={<GoogleIcon size={size === "lg" ? 22 : 18} />}
      label="Doorgaan met Google"
      size={size}
    />
  );
}
